import React from "react";
import { useLocation } from "react-router-dom";

import PropTypes from "prop-types";
import ROUTES from "Constants/routes";
import AutoLogin from "Containers/AutoLogin";

import Countdown from "Components/@propellerads/countdown";
import Alert from "@propellerads/alert";
import Button, { BUTTON_TYPE } from "@propellerads/button";

import "./styles.scss";
import Translate from "Components/Translate";

function AutoLoginPanel({
  isAuthenticated,
  countdownTime,
  isReadOnly,
  logoutAction,
  email,
  userId,
}) {
  const location = useLocation();

  const AutoLoginPanelView = ({ noticeMsg, buttonType }) => (
    <div className="AutoLoginPanel">
      <Alert>
        <span>{noticeMsg}</span>
        <Countdown
          time={countdownTime}
          runCountdown={isAuthenticated}
          doneCallback={() => logoutAction()}
          isFormatted
        />
        {" (or less)"}
        <Button
          elementId="logout-from-read-only"
          onClick={() => logoutAction()}
          type={buttonType}
        >
          <Translate tag="header_logout" />
        </Button>
      </Alert>
    </div>
  );
  AutoLoginPanelView.propTypes = {
    noticeMsg: PropTypes.string.isRequired,
    buttonType: PropTypes.oneOf([BUTTON_TYPE.ADVANCED, BUTTON_TYPE.DANGER])
      .isRequired,
  };

  if (location.pathname === ROUTES.AUTH.AUTO_LOGIN) {
    if (!isAuthenticated) {
      return <AutoLogin />;
    }

    return (
      <AutoLoginPanelView
        noticeMsg={`You MUST logout to change user!\nYou're still in READ-ONLY mode (pretending to be user (${email}) with id: ${userId}). AutoLogout in ~ `}
        buttonType={BUTTON_TYPE.DANGER}
      />
    );
  }

  if (isAuthenticated && isReadOnly) {
    return (
      <AutoLoginPanelView
        noticeMsg={`You're in READ-ONLY mode (pretending to be user (${email}) with id: ${userId}). AutoLogout in ~ `}
        buttonType={BUTTON_TYPE.ADVANCED}
      />
    );
  }

  return null;
}

AutoLoginPanel.propTypes = {
  countdownTime: PropTypes.number,
  isReadOnly: PropTypes.bool,
  isAuthenticated: PropTypes.bool,
  logoutAction: PropTypes.func.isRequired,
  email: PropTypes.string,
  userId: PropTypes.number,
};

AutoLoginPanel.defaultProps = {
  countdownTime: undefined,
  isReadOnly: false,
  isAuthenticated: false,
  email: "",
  userId: undefined,
};

export default AutoLoginPanel;
